import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StudentDataModel } from 'data/student/student.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: StudentDataModel;
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: { totalCount: 0, page: 0, limit: 0, data: [] },
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<StudentDataModel>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: { totalCount: 0, page: 0, limit: 0, data: [] },
  status: 'error',
});

const studentDataSlice = createSlice({
  name: 'studentData',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default studentDataSlice;
